import React, { Component } from 'react';
import autoBind from 'react-autobind';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import links from 'utils/links';
import { Link } from 'react-router-dom';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const styles = theme => ({
  card: {
    paddingTop: theme.spacing.unit + 2,
    backgroundColor: '#fff',
  },
  imageContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    float: 'left',
    paddingRight: theme.spacing.unit * 2 + 4,
    paddingLeft: theme.spacing.unit * 2 + 4,
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
    border: '2px solid #808080',
    borderRadius: '50%',
  },
  avatar: {
    margin: 3,
  },
  bigAvatar: {
    width: '70px',
    height: '70px',
    backgroundColor: '#d5d5d54a',
  },
  member_name: {
    textAlign: 'center',
  },
  button: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main,
  },
  cuisineBtnBox: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  cuisineButton: {
    height: '25px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '5px',
    backgroundColor: '#eceaea',
    margin: theme.spacing.unit - 3,
    border: '0px',
  },
  chip: {
    margin: theme.spacing.unit,
  },
});

class ContributorContributions extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      following: false,
      open: false,
    };
  }

  followerHandler = e => {
    this.setState({ following: !this.state.following });
  };
  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes, cuisines, name, img, oneLineDesc, id } = this.props;
    return (
      <Card className={classes.card}>
        <div className={classes.imageContainer}>
          <div className={classes.row}>
            <Link to={links.contributorProfileLinks(id)}>
              <Avatar
                alt={name}
                src={img}
                className={classNames(classes.avatar, classes.bigAvatar)}
              />
            </Link>
          </div>
          <Typography
            className={classes.member_name}
            component="h3"
            variant="h6"
          >
            <Link to={links.contributorProfileLinks(id)}>{name}</Link>
          </Typography>
          <div className={classes.cuisineBtnBox}>
            {cuisines.map(cuisine => {
              return (
                <Chip
                  label={cuisine}
                  className={classes.cuisineButton}
                  key={cuisine}
                  variant="outlined"
                />
              );
            })}
          </div>
          <Typography variant="subtitle2" style={{ textAlign: 'justify' }}>
            {oneLineDesc}
          </Typography>
          {localStorage.getItem('tsUserInfo') ? (
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
              onClick={e => this.followerHandler(e)}
            >
              {this.state.following === true ? 'Unfollow' : 'Follow'}
            </Button>
          ) : (
            <div>
              <Button
                variant="contained"
                color="secondary"
                className={classes.button}
                onClick={this.handleClickOpen}
              >
                Follow
              </Button>
              <Dialog
                open={this.state.open}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  {'Talking Street '}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Please Sign-in or Sign-up to follow Pundits
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.handleClose} color="primary" autoFocus>
                    Ok
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
          )}
        </div>
      </Card>
    );
  }
}

ContributorContributions.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ContributorContributions);
